export enum PrErrorCodeEnum {
  // File API errors
  FILE_API_CONNECTION_FAILED = 1001,
  FILE_API_UPLOAD_FAILED = 1002,
  FILE_API_BAD_REQUEST = 1003,
  FILE_API_TIMEOUT = 1004,
  FILE_API_AUTHENTICATION_FAILED = 1005,
  FILE_API_NOT_FOUND = 1006,
  FILE_API_PERMISSION_DENIED = 1007,
  FILE_API_CONFILCT = 1008,

  // MyDocma API errors
  MYDOCMA_API_AUTHORIZATION_FAILED = 2001,
  URL_SHORTENER_API_ERROR = 2002,

  // PR processing errors
  PR_DOC_NOT_FOUND = 3001,
  PR_FILE_NOT_FOUND = 3002,
  PR_DELETE_FAILED = 3003,
  PR_CONFIG_FETCH_FAILED = 3004,
  PR_FILE_IN_USE_WITH_OTHER_DOCUMENTS = 3005,
  PR_ARCHIVE_PREVIEW_GENERATION_FAILED = 3006,
  PR_OFFICE_PREVIEW_GENERATION_FAILED = 3007,
  PR_UNSUPPORTED_PREVIEW_FILE_TYPE = 3008,
  PR_FILE_TYPE_DETECTION_FAILED = 3009,
  PR_FILE_REF_NOT_FOUND = 3010,
  PR_NO_CHANGES_DETECTED = 3011,
  PR_DOC_HISTORY_NOT_FOUND = 3012,
  PR_DOWNLOAD_SIZE_EXCEEDED = 3013,
  PR_SHARED_DOC_NOT_FOUND = 3014,
  PR_SHARED_FILE_FORBIDDEN = 3015,
  PR_SHARED_DOC_FORBIDDEN = 3016,
  PR_SHARED_CREATION_FAILED = 3017,
  PR_EMAIL_PREVIEW_GENERATION_FAILED = 3018,
  PR_DOC_UPDATE_FAILED = 3019,
  PR_FILE_DELETE_FAILED = 3020,
  PR_FILE_ALREADY_DELETED = 3021,
  PR_LAST_FILE_DELETE_NOT_ALLOWED = 3022,

  // Request validation errors
  REQUEST_INVALID_JSON = 4001,
  REQUEST_VALIDATION_FAILED = 4002,
  REQUEST_MISSING_FIELDS = 4003,
  REQUEST_INVALID_IDS = 4004,
  REQUEST_FILE_SIZE_EXCEEDED = 4005,
  REQUEST_MISSING_FILE_OR_FILE_ID = 4006,
  REQUEST_TOO_MANY_ITEMS = 4007,
  REQUEST_CONFLICTING_FILE_INPUT = 4008,
  REQUEST_INVALID_GROUPING_FIELD = 4009,
  REQUEST_INVALID_SORTING_FIELD = 4010,
  REQUEST_INVALID_FILTER_FIELD = 4011,
  REQUEST_INVALID_FILTER_OPERATOR = 4012,
  REQUEST_INVALID_FILETYPE_ARRAY = 4013,
  REQUEST_INVALID_FILETYPE_VALUE = 4014,
  REQUEST_TIME_INVALID = 4015,
  REQUEST_INVALID_FILES_ORDER = 4016,
  
  // Folders errors
  FOLDER_NOT_FOUND = 5001,
  FOLDER_INVALID_OPERATION = 5002,
  FOLDER_UPDATE_FAILED = 5003,
  FOLDER_DELETE_FAILED = 5004,

  // Document type errors
  DOC_TYPE_NOT_FOUND = 6001,
  DOC_TYPE_ALREADY_EXISTS = 6002,
  DOC_TYPE_INVALID_OPERATION = 6003,
  DOC_TYPE_UPDATE_FAILED = 6004,
  DOC_TYPE_DELETE_FAILED = 6005,
  DOC_TYPE_CREATION_FAILED = 6006,
  DOC_TYPE_EXISTS_CHECK_FAILED = 6007,
  DOC_TYPE_CREATE_SUBTYPE_FAILED = 6008,
  DOC_TYPE_UPDATE_SUBTYPE_FAILED = 6009,
  DOC_TYPE_DELETE_SUBTYPE_FAILED = 6010,
  DOC_TYPE_SUBTYPE_NOT_FOUND = 6011,
  DOC_TYPE_SUBTYPE_ALREADY_EXISTS = 6012,
  DOC_TYPE_FETCH_FAILED = 6014,

  // Dashboard errors
  PR_DASHBOARD_GET_FILTER_OPTIONS_FAILED = 7001,
  PR_DASHBOARD_GET_DOC_ACTIVITY_FAILED = 7002,
  PR_DASHBOARD_GET_DATA_FAILED = 7003,
}

export const PR_ERROR_MESSAGES: Record<string, string> = {
  [PrErrorCodeEnum.PR_DELETE_FAILED]: 'Invalid document ID(s) provided.',
  [PrErrorCodeEnum.PR_DOC_UPDATE_FAILED]: 'PR.documentDetails.notification.documentUpdateUploadError',
  [PrErrorCodeEnum.PR_FILE_DELETE_FAILED]: 'PR.documents.notifications.fileDeleteFailed',
  [PrErrorCodeEnum.PR_FILE_ALREADY_DELETED]: 'PR.documents.notifications.fileAlreadyDeleted',
  [PrErrorCodeEnum.PR_LAST_FILE_DELETE_NOT_ALLOWED]:
    'PR.documents.notifications.lastFileDeleteNotAllowed',
  [PrErrorCodeEnum.DOC_TYPE_NOT_FOUND]:
    'Document type cannot be saved. Please try again later.',
  [PrErrorCodeEnum.DOC_TYPE_ALREADY_EXISTS]: 'Document type already exists.',
  [PrErrorCodeEnum.DOC_TYPE_INVALID_OPERATION]:
    'Document type cannot be deleted. Please try again later.',
  [PrErrorCodeEnum.DOC_TYPE_CREATION_FAILED]:
    'Document type cannot be created. Please try again later.',
  [PrErrorCodeEnum.DOC_TYPE_UPDATE_FAILED]:
    'Document type cannot be saved. Please try again later.',
  [PrErrorCodeEnum.DOC_TYPE_DELETE_FAILED]:
    'Document type cannot be deleted. Please try again later.',
  [PrErrorCodeEnum.DOC_TYPE_CREATE_SUBTYPE_FAILED]:
    'Document sub type cannot be created. Please try again later.',
  [PrErrorCodeEnum.DOC_TYPE_UPDATE_SUBTYPE_FAILED]:
    'Document type cannot be saved. Please try again later.',
  [PrErrorCodeEnum.DOC_TYPE_DELETE_SUBTYPE_FAILED]:
    'Document sub type cannot be deleted. Please try again later.',
  [PrErrorCodeEnum.DOC_TYPE_SUBTYPE_NOT_FOUND]:
    'Document sub type cannot be saved. Please try again later.',
  [PrErrorCodeEnum.DOC_TYPE_SUBTYPE_ALREADY_EXISTS]: 'Sub type already exists.',
  [PrErrorCodeEnum.DOC_TYPE_FETCH_FAILED]:
    'Document types cannot be fetched. Please try again later.',
};
